import { useState } from 'react';

interface UseStepperResponse {
  activeStep: number;
  nextStep: () => void;
  previousStep: () => void;
  defineStep: (step: number) => void;
}
/**
 * Custom Hook que retorna funções prontas para ser usado em algum Stepper
 * de acordo com o número do parâmetro `steps`
 *
 * @export
 * @param {number} steps - Número de steps necessários
 * @return {*}  {UseStepperResponse}
 */
export function useStepper(
  steps: number,
): UseStepperResponse {
  const [activeStep, setActiveStep] = useState(1);

  const nextStep = (): void => {
    if (activeStep < steps) setActiveStep((prev) => prev + 1);
  };

  const previousStep = (): void => {
    if (activeStep > 1) setActiveStep((prev) => prev - 1);
  };

  const defineStep = (step: number): void => {
    if (step >= 1 && step <= steps) {
      setActiveStep(step);
    }
  };

  return {
    nextStep,
    previousStep,
    activeStep,
    defineStep,
  };
}
